import { memo } from "react";
import { FormattedMessage } from "react-intl";
import LogoBrand from "app/pages/.shared/LogoBrand/LogoBrand";
import { BRANDS } from "app/constants";
import "./PartnershipWithPFSLabel.scss";
import PropTypes from "prop-types";

const PartnershipWithPFSLabel = ({ isWhite = false }) => {
	return (
		<div className="partnership-with-pfs">
			<FormattedMessage id="general.partnership.with.pfs" />
			<div className="partnership-with-pfs__logo">
				<LogoBrand brand={BRANDS.XX} shop="fr-FR" isWhite={isWhite} />
			</div>
		</div>
	);
};

PartnershipWithPFSLabel.propTypes = {
	isWhite: PropTypes.bool,
};

export default memo(PartnershipWithPFSLabel);
